import languageLoader from "@/js/language-loader";
export default {
	lang: languageLoader(),
	phoneNumber: '+52 1 998 105 7370'
};
